'use client'

import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { UserType } from '@/entities/user'
import { useRouter } from '@/shared/i18n'
import { getURLWithParams } from '@/shared/lib'
import { SearchBar } from '@/shared/ui'

type Props = {
  keyword?: string
  userType: UserType
}

export const Search = ({ keyword, userType }: Props) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const t = useTranslations('faq')

  const [value, setValue] = useState(keyword ?? '')

  const handleSearch = () => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')

    const category = searchParams?.get('category')
    const page = searchParams?.get('page')

    const returnTo = getURLWithParams(`/${userType}/support/faq`, {
      category,
      page,
    })

    params.delete('page')
    params.delete('category')

    if (value) {
      params.set('keyword', value)
      params.set('returnTo', returnTo)
    } else {
      params.delete('keyword')
    }

    router.push(`?${params.toString()}`)
  }

  return (
    <SearchBar
      value={value}
      onChange={setValue}
      onSearch={handleSearch}
      placeholder={t('search.placeholder')}
      className="w-full border-b border-b-black pl-0 [&>*:first-child]:-ml-[11px]"
    />
  )
}
